import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { search } from '@adc/blueprint'
import cls from './styles.scss'

const cx = classNames.bind(cls)

const HighlightedMatches = ({ suggestion, searchText }) => {
  const { label } = suggestion
  const { offsets } = search.utils.findMatchingText(suggestion, searchText)
  const parts = []
  let lastIndex = 0

  offsets.forEach(([startIndex, endIndex], index) => {
    parts.push(
      <React.Fragment key={index}>
        {label.substring(lastIndex, startIndex)}
      </React.Fragment>
    )
    parts.push(
      <span key={`b-${index}`} className={cx('highlighted')}>
        {label.substring(startIndex, endIndex)}
      </span>
    )
    lastIndex = endIndex
  })

  parts.push(
    <React.Fragment key={offsets.length}>
      {label.substring(lastIndex)}
    </React.Fragment>
  )

  return <>{parts}</>
}

HighlightedMatches.propTypes = {
  suggestion: PropTypes.object,
  searchText: PropTypes.string,
}

export default HighlightedMatches
